export default __webpack_public_path__ + "static/media/atuacao_img_3.4b14f534.svg";